











































import { Component, Prop, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import ModalHeader from "@/components/ModalHeader.vue";

@Component({
  components: {
    ModalHeader
  },
  computed: mapState("gaps", ["priority"])
})
export default class GapPriority extends Vue {
  @Prop(Array) readonly items!: Array<any>;
  priorityId: string | null = null;
  async save() {
    if (!this.priorityId) return;
    this.$store.commit("main/SET_LOADING", true);
    try {
      const gapList = this.items.map(item => item.id).join();
      const { priorityId } = this;
      await this.$store.dispatch("gaps/savePriority", {
        gapList,
        priorityId
      });
      this.$emit("priority-saved");
      this.$modal.hide("gap-priority");
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
}
